import { render, staticRenderFns } from "./CertificatesShare.vue?vue&type=template&id=6f41fdd2&scoped=true"
import script from "./CertificatesShare.vue?vue&type=script&lang=js"
export * from "./CertificatesShare.vue?vue&type=script&lang=js"
import style0 from "./CertificatesShare.vue?vue&type=style&index=0&id=6f41fdd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f41fdd2",
  null
  
)

export default component.exports